const MARCADOR_SALTO_PAGINA_RE = /__DOCX_SALTO_PAGINA__:(\d+)__/g
const RUN_RE = /<w:r(?:\s[^>]*)?>[\s\S]*?<\/w:r>/g

function construirParrafosSaltoPagina(cantidad) {
  return '<w:p><w:r><w:br w:type="page"/></w:r></w:p>'.repeat(cantidad)
}

function construirRunTexto(aperturaRun, propiedadesRun, atributosTexto, contenido) {
  if (!contenido) return ''
  return `${aperturaRun}${propiedadesRun || ''}<w:t${atributosTexto}>${contenido}</w:t></w:r>`
}

function construirRunSaltoPagina(cantidad, propiedadesRun) {
  return (`<w:r>${propiedadesRun || ''}<w:br w:type="page"/></w:r>`).repeat(cantidad)
}

function transformarContenidoTexto(contenido, aperturaRun, propiedadesRun, atributosTexto) {
  let resultado = ''
  let lastIndex = 0
  let match

  MARCADOR_SALTO_PAGINA_RE.lastIndex = 0
  while ((match = MARCADOR_SALTO_PAGINA_RE.exec(contenido)) !== null) {
    const cantidad = Number(match[1])
    if (!Number.isInteger(cantidad) || cantidad < 1) continue

    resultado += construirRunTexto(
      aperturaRun,
      propiedadesRun,
      atributosTexto,
      contenido.slice(lastIndex, match.index)
    )
    resultado += construirRunSaltoPagina(cantidad, propiedadesRun)
    lastIndex = MARCADOR_SALTO_PAGINA_RE.lastIndex
  }

  resultado += construirRunTexto(
    aperturaRun,
    propiedadesRun,
    atributosTexto,
    contenido.slice(lastIndex)
  )

  return resultado
}

function transformarRun(runXml) {
  if (!runXml.includes('__DOCX_SALTO_PAGINA__:')) return runXml

  const match = runXml.match(
    /^(<w:r(?:\s[^>]*)?>)(\s*<w:rPr>[\s\S]*?<\/w:rPr>\s*)?<w:t([^>]*)>([\s\S]*?)<\/w:t>\s*<\/w:r>$/
  )
  if (!match) return runXml

  const aperturaRun = match[1]
  const propiedadesRun = match[2] || ''
  const atributosTexto = match[3] || ''
  const contenido = match[4] || ''

  return transformarContenidoTexto(contenido, aperturaRun, propiedadesRun, atributosTexto)
}

function buscarUltimaEtiqueta(xml, patron, hasta) {
  const regex = new RegExp(patron, 'g')
  let encontrada = null
  let match

  while ((match = regex.exec(xml)) !== null) {
    if (match.index > hasta) break
    encontrada = match
  }

  return encontrada ? encontrada.index : -1
}

function buscarTablaContenedora(xml, posicion) {
  const inicioTabla = buscarUltimaEtiqueta(xml, '<w:tbl(?:\\s[^>]*)?>', posicion)
  if (inicioTabla === -1) return null

  const cierreTablaRel = xml.slice(posicion).indexOf('</w:tbl>')
  if (cierreTablaRel === -1) return null

  const finTabla = posicion + cierreTablaRel + '</w:tbl>'.length
  const cierreAntes = xml.lastIndexOf('</w:tbl>', posicion)
  if (cierreAntes > inicioTabla) return null

  return { inicio: inicioTabla, fin: finTabla }
}

function buscarFilaContenedora(xml, posicion, tabla) {
  const inicioFila = buscarUltimaEtiqueta(xml, '<w:tr(?:\\s[^>]*)?>', posicion)
  if (inicioFila === -1 || inicioFila < tabla.inicio) return null

  const cierreFilaRel = xml.slice(posicion).indexOf('</w:tr>')
  if (cierreFilaRel === -1) return null

  const finFila = posicion + cierreFilaRel + '</w:tr>'.length
  if (finFila > tabla.fin) return null

  return { inicio: inicioFila, fin: finFila }
}

function extraerCabeceraTabla(xmlTabla) {
  const aperturaMatch = xmlTabla.match(/^<w:tbl(?:\s[^>]*)?>/)
  if (!aperturaMatch) return null

  const apertura = aperturaMatch[0]
  const primerFila = xmlTabla.indexOf('<w:tr', apertura.length)
  if (primerFila === -1) return null

  return {
    apertura,
    propiedades: xmlTabla.slice(apertura.length, primerFila),
  }
}

function resolverSaltosEnTablas(xml) {
  let resultado = xml
  let desde = 0

  while (desde < resultado.length) {
    MARCADOR_SALTO_PAGINA_RE.lastIndex = desde
    const match = MARCADOR_SALTO_PAGINA_RE.exec(resultado)
    if (!match) break

    const cantidad = Number(match[1])
    if (!Number.isInteger(cantidad) || cantidad < 1) {
      desde = MARCADOR_SALTO_PAGINA_RE.lastIndex
      continue
    }

    const posicionMarcador = match.index
    const tabla = buscarTablaContenedora(resultado, posicionMarcador)
    if (!tabla) {
      desde = MARCADOR_SALTO_PAGINA_RE.lastIndex
      continue
    }

    const fila = buscarFilaContenedora(resultado, posicionMarcador, tabla)
    if (!fila) {
      desde = MARCADOR_SALTO_PAGINA_RE.lastIndex
      continue
    }

    const xmlTabla = resultado.slice(tabla.inicio, tabla.fin)
    const cabecera = extraerCabeceraTabla(xmlTabla)
    if (!cabecera) {
      desde = MARCADOR_SALTO_PAGINA_RE.lastIndex
      continue
    }

    const tablaHastaFila = resultado
      .slice(tabla.inicio, fila.fin)
      .replace(match[0], '')
    const cierreTabla = '</w:tbl>'
    const filasRestantes = resultado.slice(fila.fin, tabla.fin - cierreTabla.length)
    const tablaSiguiente = filasRestantes.includes('<w:tr')
      ? `${cabecera.apertura}${cabecera.propiedades}${filasRestantes}${cierreTabla}`
      : ''

    resultado =
      resultado.slice(0, tabla.inicio) +
      tablaHastaFila +
      cierreTabla +
      construirParrafosSaltoPagina(cantidad) +
      tablaSiguiente +
      resultado.slice(tabla.fin)

    desde = tabla.inicio + tablaHastaFila.length + cierreTabla.length
  }

  return resultado
}

export function resolverSaltosPagina(xml) {
  return resolverSaltosEnTablas(xml).replace(RUN_RE, transformarRun)
}
